// extracted by mini-css-extract-plugin
export default {"countdown":"styles_countdown__XPrI7"};